import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
  APPLICATION_LIST_LOADDATA,
  APPLICATION_LIST_SUCCESS,
  APPLICATION_STATUS_CHANGE,
  APPLICATION_STAGE_LOADDATA,
  APPLICATION_ASSIGN,
  APPLICATION_CALLNUMBER,
} from "../constants/ApplicationlistConst";
import {
  success,
  stagessuccess,
  assignsuccess,
} from "../actions/ApplicationlistActions";
import ApplicationService from "../../services/ApplicationService";
import {
  callnumberfailed,
  callnumbersuccess,
  statuschangesuccess,
} from "../actions";

export function* loaddata() {
  yield takeEvery(APPLICATION_LIST_LOADDATA, function* (payload) {
    try {
      const res = yield call(ApplicationService.getAll, payload);
      console.log("->>>>>>>>>>");
      yield put(success(res.data.data));
      console.log(res);
    } catch (err) {
      console.log("->>>>>>>>>> error");
      console.log(err);
    }
  });
}

export function* loadstagesdata() {
  yield takeEvery(APPLICATION_STAGE_LOADDATA, function* (payload) {
    try {
      const res = yield call(
        ApplicationService.getStages,
        payload.id,
        payload.app_id
      );
      console.log("->>>>>>>>>>");
      yield put(stagessuccess(res.data.data));
      console.log(res);
    } catch (err) {
      console.log("->>>>>>>>>> error");
      console.log(err);
    }
  });
}

export function* changestatus() {
  yield takeEvery(APPLICATION_STATUS_CHANGE, function* (payload) {
    try {
      const res = yield call(
        ApplicationService.updateStatus,
        payload.id,
        payload
      );
      yield put(statuschangesuccess(res.data.data));
      yield put({ type: APPLICATION_LIST_LOADDATA });
      const all = yield call(ApplicationService.getAll);
      yield put(success(all.data.data));
      // yield put(loaddata({page}));
      // yield put({ type: APPLICATION_LIST_LOADDATA });
      console.log("mmmmmmmmmmmmmmmmm");
    } catch (err) {
      console.log("->>>>>>>>>> error");
      console.log(err);
    }
  });
}

export function* assignapplication() {
  yield takeEvery(APPLICATION_ASSIGN, function* (payload) {
    try {
      const res = yield call(
        ApplicationService.assignApplication,
        payload.id,
        payload
      );
      console.log("->>>>>>>>>>");
      yield put(assignsuccess(res.data.data));
      yield put({ type: APPLICATION_LIST_LOADDATA });
      const all = yield call(ApplicationService.getAll);
      yield put(success(all.data.data));
      console.log(res);
    } catch (err) {
      console.log("->>>>>>>>>> error");
      console.log(err);
    }
  });
}

export function* updateCallNumber() {
  yield takeEvery(APPLICATION_CALLNUMBER, function* (payload) {
    try {
      const res = yield call(
        ApplicationService.updateNumber,
        payload.id,
        payload
      );
      console.log("->>>>>>>>>>");
      yield put(callnumbersuccess(res.data.data));
      yield put({ type: APPLICATION_LIST_LOADDATA });
      const all = yield call(ApplicationService.getAll);
      yield put(success(all.data.data));
      console.log(res);
    } catch (err) {
      yield put(callnumberfailed(err.response.data.message));

      console.log("->>>>>>>>>> error");
      console.log(err.response);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(loaddata),
    fork(loadstagesdata),
    fork(changestatus),
    fork(assignapplication),
    fork(updateCallNumber),
  ]);
}
